import React from 'react'
import MainMenu from '../components/MainMenu.jsx'
import AdminDatabaseRequest from '../components/AdminDatabaseRequests.jsx'
import Footer from '../../../../global/components/Footer.jsx'
import '../styles/AdminDatabasePage.css'

const AdminDatabaseRequestPage =({})=> {
    return(
        <React.Fragment>
            <div id="AdminDatabaseRequestPage">
                <AdminDatabaseRequest/>
            </div>
            <Footer />
        </React.Fragment>
    )
}
export default AdminDatabaseRequestPage
